import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarModulesComponent } from './components/sidebar/sidebar-modules/sidebar-modules.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { SearchComponent } from './components/header/search/search.component';
import { ServiciosEntidadesComponent } from './components/servicios-entidades/servicios-entidades.component';
import { SharedModule } from '../shared/shared.module';
import { CandyBoxComponent } from './components/header/candy-box/candy-box.component';
import { VersionMenuComponent } from './components/header/version-menu/version-menu.component';
import { NoteComponent } from './components/note/note.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    SidebarModulesComponent,
    SearchComponent,
    ServiciosEntidadesComponent,
    CandyBoxComponent,
    VersionMenuComponent,
    NoteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    SharedModule
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    SidebarModulesComponent,
    ServiciosEntidadesComponent,
    NoteComponent
  ],
})
export class CoreModule { }
